export const FILL_METHOD = {
  METHOD: { MANUAL_FILL: 'manual_fill', AUTO_FILL: 'auto_fill' },
  AUTO_FILL_METHOD: { OPEN_LINK: 'open_link', SEND_EMAIL: 'send_email' },
}
